/* eslint-disable no-underscore-dangle */

import { useState, useCallback } from 'react'

export const DATA_DSUI_MODAL = 'data-dsui-modal'

/**
 * Determines if an element is rendered inside a Modal. The supplied `refCallback` should be
 * given to the element in question. If the element is unmounted `inModal` will be undefined,
 * which should be interpreted as "unknown". It will always be undefined on the first render.
 *
 * @example
 * const Component = () => {
 *   const { refCallback, inModal } = useModalDetection()
 *
 *   return (
 *     <div ref={refCallback}>
 *       Rendered in a modal = {inModal}
 *     </div>
 *   )
 * }
 */
export const useModalDetection = () => {
  const [inModal, setInModal] = useState<boolean | undefined>(undefined)

  const refCallback = useCallback((element: HTMLElement | null) => {
    if (element) {
      setInModal(isRenderedInModal(element))
    } else {
      setInModal(undefined)
    }
  }, [])

  return {
    refCallback,
    inModal,
  }
}

const isRenderedInModal = (node: Node) => {
  let _node: Node | null = node

  while (_node) {
    if (
      _node.parentNode instanceof HTMLElement &&
      _node.parentNode.hasAttribute(DATA_DSUI_MODAL)
    ) {
      return true
    }
    _node = _node.parentNode
  }

  return false
}
